<div class="container-fluid p-4">
  <div class="row mb-3">
    <div class="col-md-12">
      <button class="btn btn-secondary" (click)="goBack()" title="Return to audit records list">← Back</button>
      <h1 class="d-inline ms-3">Audit Record Detail</h1>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12 mb-3">
      <div class="card">
        <div class="card-header bg-primary text-white">
          <h5 class="mb-0">Search JSON</h5>
        </div>
        <div class="card-body">
          <p *ngIf="!searchJson" class="text-muted"><em>No search JSON available.</em></p>
          <pre *ngIf="searchJson" class="bg-light p-3 rounded" style="max-height: 400px; overflow-y: auto;"><code>{{ formattedSearchJson }}</code></pre>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header bg-secondary text-white">
          <h5 class="mb-0">Result JSON</h5>
        </div>
        <div class="card-body">
          <p *ngIf="!resultJson" class="text-muted"><em>No result JSON available.</em></p>
          <pre *ngIf="resultJson" class="bg-light p-3 rounded" style="max-height: 400px; overflow-y: auto;"><code>{{ formattedResultJson }}</code></pre>
        </div>
      </div>
    </div>
  </div>
</div>

